import { ReactElement, ReactNode, useMemo } from "react";
import { Loading } from "src/components/Feedback/Loading";
import { useUserPermissions } from "src/hooks/useUserPermissions";
import { Permission } from "src/types/permissions";

type Props = {
  children: ReactNode | ReactNode[];
  permissions: Permission[];
  /**
   * When specified, If the user does not have the permission, this component will be rendered instead of the children.
   */
  orElse?: ReactElement;
  loadingIndicator?: ReactNode;
  permissionMatch?: "all" | "any";
};

export const WithUserPermissions = ({
  children,
  permissions,
  orElse = <></>,
  permissionMatch = "any",
  loadingIndicator: loading,
}: Props) => {
  const userPermissions = useUserPermissions();
  const hasPermissions = useMemo(
    () =>
      permissionMatch === "any"
        ? userPermissions.hasSome(permissions)
        : userPermissions.hasAll(permissions),
    [permissionMatch, userPermissions, permissions]
  );

  if (userPermissions.isLoading) {
    return loading ?? <Loading />;
  }

  return hasPermissions ? <>{children}</> : orElse;
};
